<mat-card appearance="raised" class="no-margin">
  <vdw-header [title]="finishing.nameWithVersion" [canShowClose]="'true'" svgIcon="info"></vdw-header>

  <mat-card-content>
    <article>
      <div class="flex-column gap-16">
        <app-disabled-form-input [label]="'GENERAL.TYPE' | bmsTranslate" [value]="getFinishingType()"></app-disabled-form-input>
        <app-disabled-form-input [label]="'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.LABEL' | bmsTranslate: {count: 1}" [value]="getFinishingLabel()"></app-disabled-form-input>
        <app-disabled-form-input [label]="'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.PLACE_OPTIONS.CUTBAR_BEFORE' | bmsTranslate" [value]="getCutbarBefore()"></app-disabled-form-input>
        <app-disabled-form-input [label]="'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.PLACE_OPTIONS.CUTBAR_AFTER' | bmsTranslate" [value]="getCutbarAfter()"></app-disabled-form-input>
      </div>
    </article>
  </mat-card-content>
</mat-card>
